import React from "react";
import styles from "./SelectionIndicator.module.css";
import plusIcon from "../../assets/icons/plusIcon.svg";

interface SelectionIndicatorProps {
    isSelected: boolean;
    onToggle: () => void;
}

const SelectionIndicator: React.FC<SelectionIndicatorProps> = ({ isSelected, onToggle }) => {
    return (
        <div
            className={`${styles.checkContainer} ${isSelected ? styles.checked : styles.unChecked}`}
            onClick={onToggle}
        >
            {isSelected && (
                <img src={plusIcon} alt="Selected" className={styles.plusIcon} />
            )}
        </div>
    );
};

export default SelectionIndicator;